<template>
  <div v-if="currentUser.id && isReady">
    <ReportPageV2 v-if="!canUseMultipleSessions" />
    <div v-else>
      <ReportPageV2 v-if="isRenderedReport" :key="selectedSession?.presentationId || 'no-session'" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import ReportPageV2 from '@/components-v2/presentation-report/ReportPageV2.vue'

export default {
  components: {
    ReportPageV2,
  },
  data() {
    return {
      isReady: false,
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
      presenterLocale: (state) => state.presenterLocale,
    }),
    ...mapGetters('multipleSessions', ['canUseMultipleSessions', 'selectedSession', 'isRenderedReport']),
  },
  created() {
    this.setDefaultSelectedSession(null)
  },
  mounted() {
    this.initFeatureContext()
  },
  methods: {
    ...mapActions('multipleSessions', ['setDefaultSelectedSession']),
    ...mapActions('featureToggles', ['initializeUserFeatureContext']),
    async initFeatureContext() {
      await this.initializeUserFeatureContext({
        currentUser: this.currentUser,
        presenterLanguage: this.presenterLocale,
      })
      this.isReady = true
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
